import { useSelector } from 'react-redux';
import { selectFilterResultsMembers, selectHasFiltersSet } from 'find-and-filter-data/search-and-filter-data/protected';
import NoSearchResults from './NoSearchResults';
import SearchNoThreadFocused from './SearchNoThreadFocused';
import SearchResultsZeroState from './SearchResultsZeroState';
import InboxThreadOverview from '../../unified-inbox/components/InboxThreadOverview';
import { getCurrentInboxName } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchAndFilteringMainViewContent = ({
  focusedThreadId
}) => {
  const threadListMembers = useSelector(selectFilterResultsMembers);
  const hasFiltersSet = useSelector(selectHasFiltersSet);
  const inboxName = useSelector(getCurrentInboxName);
  const showZeroState = !hasFiltersSet;
  const showNoResultsState = hasFiltersSet && threadListMembers && threadListMembers.size === 0;
  const showSelectAThread = hasFiltersSet && threadListMembers && threadListMembers.size > 0 && !focusedThreadId;
  if (focusedThreadId) {
    return /*#__PURE__*/_jsx(InboxThreadOverview, {
      focusedThreadId: focusedThreadId
    });
  }
  if (showNoResultsState) {
    return /*#__PURE__*/_jsx(NoSearchResults, {});
  }
  if (showZeroState) {
    return /*#__PURE__*/_jsx(SearchResultsZeroState, {
      inboxName: inboxName
    });
  }
  if (showSelectAThread) {
    return /*#__PURE__*/_jsx(SearchNoThreadFocused, {});
  }
  return null;
};
SearchAndFilteringMainViewContent.displayName = 'SearchAndFilteringMainViewContent';
export default SearchAndFilteringMainViewContent;